const messages = {
  copy: 'Copy',
  copyOrders: 'Copy Orders',
  duplicate: 'Duplicate',
  duplicateOrders: 'Duplicate Orders',
  selectOne: 'Select one',
  selectRetailer: 'Select a retailer to copy order(s) for',
  selectRetailerToDuplicate: 'Select a retailer to duplicate order(s) for',
  startTyping: 'Start typing to search...',
}

export default messages
